import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaOrganizationProps {
    name?: string;
    alternateName?: string[];
    logoPath?: string;
    logoWidth?: number;
    logoHeight?: number;
    sameAs?: string[];
}

export function SeoSchemaOrganization({
                                          name = "ACTIVE",
                                          alternateName = ["AVD", "Advanced Vapor Devices"],
                                          logoPath = "/images/optimizedImages/footer-logo-opt-256.WEBP",
                                          logoWidth = 256,
                                          logoHeight = 26,
                                          sameAs = [
                                              "https://www.instagram.com/avd710/",
                                              "https://www.linkedin.com/company/avd710/",
                                              "https://www.linkedin.com/company/active710/",
                                          ],
                                      }: SeoSchemaOrganizationProps = {}) {
    const siteUrl = getSiteUrl();
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": name,
        "alternateName": alternateName,
        "url": siteUrl,
        "logo": {
            "@type": "ImageObject",
            "url": `${siteUrl}${logoPath.startsWith("/") ? "" : "/"}${logoPath}`,
            "width": logoWidth,
            "height": logoHeight,
        },
        "contactPoint": [
            {
                "@type": "ContactPoint",
                "telephone": "+1-415-320-6209",
                "contactType": "sales",
                "email": "sales@active710.com",
                "areaServed": "US",
                "availableLanguage": "en",
            },
            {
                "@type": "ContactPoint",
                "telephone": "+1-415-320-6209",
                "contactType": "technical support",
                "email": "support@active710.com",
                "areaServed": "Worldwide",
                "availableLanguage": "en",
            },
            {
                "@type": "ContactPoint",
                "contactType": "sales",
                "email": "ari@active710.com",
                "areaServed": "EU",
                "availableLanguage": "en",
            },
            {
                "@type": "ContactPoint",
                "contactType": "sales",
                "email": "hello@gsq-trading.com",
                "areaServed": "GB",
                "availableLanguage": "en",
            },
        ],
        "sameAs": sameAs,
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
